import React from 'react';
import {
  Footer,
	FooterText,
} from 'styled/Layout';
import {useTranslation} from 'react-i18next';

const ScreenFooter = () => {

  const {t} = useTranslation();

  return (
    <Footer>
      <FooterText>{t(process.env.REACT_APP_BRAND === 'gtv' ? 'footer.textGTV' : 'footer.textZiplo')}</FooterText>
    </Footer>
  );
};

export default ScreenFooter;
